import { render, staticRenderFns } from "./DetailLayoutTwoColumns.vue?vue&type=template&id=7c7a19dd&"
import script from "./DetailLayoutTwoColumns.vue?vue&type=script&lang=js&"
export * from "./DetailLayoutTwoColumns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports